module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "prelims-page",
    attrs: {
      "id": "d61713422e59b-d1e220"
    }
  }, [_c('span', {
    attrs: {
      "id": "pageii"
    }
  }, [_c('h3', {
    staticClass: "books-by-head"
  }, [_c('em', {
    staticClass: "italic "
  }, [_vm._v("The Liberty Lane Series from Caro Peacock")])]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("DEATH AT DAWN")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-space-after"
  }, [_c('em', {
    staticClass: "italic "
  }, [_vm._v("(USA: A FOREIGN AFFAIR)")])]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("DEATH OF A DANCER")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-space-after"
  }, [_c('em', {
    staticClass: "italic "
  }, [_vm._v("(USA: A DANGEROUS AFFAIR)")])]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("A CORPSE IN SHINING ARMOUR")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-space-after"
  }, [_c('em', {
    staticClass: "italic "
  }, [_vm._v("(USA: A FAMILY AFFAIR)")])]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-space-after"
  }, [_vm._v("WHEN THE DEVIL DRIVES *")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-space-after"
  }, [_vm._v("KEEPING BAD COMPANY *")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-space-after"
  }, [_vm._v("THE PATH OF THE WICKED *")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-space-after"
  }, [_vm._v("FRIENDS IN HIGH PLACES *")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_c('em', {
    staticClass: "italic "
  }, [_vm._v("* available from Severn House")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58df7a86","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9781780106601_epub_alb.vue
// module id = 63
// module chunks = 0